import { useState, useCallback, useEffect } from 'react';

export const useNotification = () => {
    const [permission, setPermission] = useState('default');
    const [isSupported, setIsSupported] = useState(false);

    useEffect(() => {
        const notificationSupported = 'Notification' in window && window.Notification !== undefined;
        setIsSupported(notificationSupported);

        if (notificationSupported) {
            setPermission(Notification.permission);
            console.log('🔔 Notification support: true');
            console.log('🔔 Current permission:', Notification.permission);
        } else {
            console.log('🔔 Notification support: false (iOS Safari)');
            setPermission('denied');
        }
    }, []);

    const requestPermission = useCallback(async () => {
        if (!isSupported) {
            console.warn('Браузерные уведомления не поддерживаются');
            return false;
        }

        try {
            console.log('🔄 Запрашиваем разрешение...');
            const result = await Notification.requestPermission();
            console.log('✅ Результат разрешения:', result);
            setPermission(result);
            return result === 'granted';
        } catch (error) {
            console.error('❌ Ошибка при запросе разрешения:', error);
            return false;
        }
    }, [isSupported]);

    const showNotification = useCallback((title, options = {}) => {
        console.log('🎯 Пытаемся показать уведомление:', { title, options });
        console.log('🎯 Permission status:', permission);

        if (!isSupported || typeof Notification === 'undefined') {
            console.warn('❌ Уведомления не поддерживаются');
            return null;
        }

        if (permission !== 'granted') {
            console.warn('❌ Нет разрешения на уведомления');
            return null;
        }

        try {
            const notification = new Notification(title, {
                icon: '/favicon.ico',
                badge: '/favicon.ico',
                ...options
            });

            console.log('✅ Уведомление создано:', notification);

            notification.onclick = () => {
                console.log('🖱️ Уведомление кликнуто');
                window.focus();
                notification.close();
                options.onClick?.();
            };

            notification.onerror = (error) => {
                console.error('❌ Ошибка уведомления:', error);
            };

            notification.onshow = () => {
                console.log('👀 Уведомление показано');
                options.onShow?.();
            };

            notification.onclose = () => {
                console.log('🚪 Уведомление закрыто');
                options.onClose?.();
            };

            setTimeout(() => {
                console.log('⏰ Автозакрытие уведомления');
                notification.close();
            }, options.duration || 5000);

            return notification;
        } catch (error) {
            console.error('💥 Критическая ошибка создания уведомления:', error);
            return null;
        }
    }, [isSupported, permission]);

    return {
        isSupported,
        permission,
        requestPermission,
        showNotification,
        canShow: isSupported && permission === 'granted'
    };
};